import React from 'react'
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
// import Portfolio from '../components/Portfolio';
import CoreValues from '../components/CoreValues';
import Technologies from '../components/Technologies';
import Contact from '../components/Contact';
import SEO from '../components/SEO';

const Home = () => {
  return (
    <div>
      <SEO 
        title="Home" 
        description="Learn about our company's journey, mission, vision, and core values. From humble beginnings to industry leadership, discover the story behind our success."
        keywords="company history, mission, vision, core values, digital transformation, innovation"
      />
        <Hero />
        <About />
        <Services />
        {/* <Portfolio /> */}
        <CoreValues />
        <Technologies />
        <Contact />
    </div>
  )
}

export default Home
